import { buildJobQueueColumns } from '../components/build-job-queue-columns';
import { useAssignFromBoard } from './use-assign-from-board';
import { useBoardTrips } from './use-board-trips';
import { useDispatchPermissions } from './use-dispatch-permissions';
import { useFleetAvailability } from './use-fleet-availability';
import { useJobQueue } from './use-job-queue';
import { useJobTypeOptions } from './use-job-type-options';
import { useSkippedJobs } from './use-skipped-jobs';

/** A stable reference: a fresh `[]` each render would re-run the queue's fetch effect forever. */
const NOTHING_EXCLUDED: string[] = [];

/** Everything the dispatch board page shows, one panel's state each; a panel that fails does not stop the others. */
export function useDispatchBoard() {
  const skipped = useSkippedJobs();
  const queue = useJobQueue(skipped.isShowingSkipped ? NOTHING_EXCLUDED : skipped.skippedIds);
  const trips = useBoardTrips();
  const fleet = useFleetAvailability();
  const assignment = useAssignFromBoard();
  const jobTypeOptions = useJobTypeOptions();
  const { canViewFleet, canDispatch } = useDispatchPermissions();
  const { reload: reloadTrips } = trips;
  const { reload: reloadQueue } = queue;
  const reloadAfterAbort = () => {
    reloadTrips();
    reloadQueue();
  };

  const columns = buildJobQueueColumns({
    jobTypeOptions,
    list: queue.list,
    actions: {
      skippedIds: skipped.skippedIds,
      assigningJobId: assignment.assigningJobId,
      failedJobId: assignment.failedJobId,
      onAssign: (jobId) => void assignment.assign(jobId),
      onSkip: skipped.skip,
      onUnskip: skipped.unskip,
    },
  });

  return {
    skipped,
    queue,
    trips,
    fleet,
    columns,
    canViewFleet,
    canDispatch,
    reloadAfterAbort,
    jobsQueued: queue.state.status === 'loaded' ? queue.state.page.total : null,
    unitsAvailable: fleet.state.status === 'loaded' ? fleet.state.fleet.units.available : null,
  };
}
